export interface AppConfigProps {
  enableRecentApps: boolean;
}

/**
 * Map from argo app stage to configuration
 */
export const AppConfigMap: Record<string, AppConfigProps> = {
  'alpha.cell-0': {
    enableRecentApps: false
  },
  'beta.cell-0': {
    enableRecentApps: false
  },
  'beta.cell-1': {
    enableRecentApps: false
  },
  'prod.cell-0': {
    enableRecentApps: false
  },
  'prod.cell-1': {
    enableRecentApps: false
  },
  'prod.cell-2': {
    enableRecentApps: false
  },
  'prod.cell-3': {
    enableRecentApps: false
  },
  'prod.cell-4': {
    enableRecentApps: false
  }
};

export type StageKey = keyof typeof AppConfigMap;
export type AppConfigKey = keyof AppConfigProps;